// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2dCRZ","title":"Header_title__tjAUM","side":"Header_side__1HZ7i"};